import { render } from "./PictureTable.vue?vue&type=template&id=713d7f9f&ts=true"
import script from "./PictureTable.vue?vue&type=script&lang=ts"
export * from "./PictureTable.vue?vue&type=script&lang=ts"

import "./PictureTable.vue?vue&type=style&index=0&id=713d7f9f&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__